import { CurrentUser } from "../models/session.models";

export function landingUrlFor(user: CurrentUser): string {
    if (user.role === "owner") return "/owner";
    if (user.role === "partner") return "/partner";
    return "/dashboard";
}
